/**
 * Build info utility for exposing deploy information in dev console.
 *
 * Usage: Call aiyaEarendil() in the browser console to see build info.
 * "Aiya Eärendil elenion ancalima!" - Frodo, in Shelob's Lair (The Two Towers)
 *
 * Requires these env vars to be set at build time:
 *   - VITE_DEPLOY_TAG (Vite apps) or NEXT_PUBLIC_DEPLOY_TAG (Next.js)
 *   - VITE_DEPLOY_AUTHOR or NEXT_PUBLIC_DEPLOY_AUTHOR
 *   - VITE_BUILD_TIME or NEXT_PUBLIC_BUILD_TIME
 *   - VITE_BUILD_DIRTY or NEXT_PUBLIC_BUILD_DIRTY
 */

const _processEnv = typeof process !== 'undefined' ? process.env : {}
// import.meta.env only exists under Vite; webpack (Next.js) leaves it undefined
const _viteEnv = (typeof import.meta !== 'undefined' && import.meta.env) || {}

const BUILD_INFO = {
    deployTag:
        _viteEnv.VITE_DEPLOY_TAG ||
        _processEnv.NEXT_PUBLIC_DEPLOY_TAG ||
        'unknown',
    author:
        _viteEnv.VITE_DEPLOY_AUTHOR ||
        _processEnv.NEXT_PUBLIC_DEPLOY_AUTHOR ||
        'unknown',
    buildTime:
        _viteEnv.VITE_BUILD_TIME ||
        _processEnv.NEXT_PUBLIC_BUILD_TIME ||
        'unknown',
    dirty:
        _viteEnv.VITE_BUILD_DIRTY ||
        _processEnv.NEXT_PUBLIC_BUILD_DIRTY ||
        'unknown',
}

/**
 * Register the aiyaEarendil function on window for console access.
 * Call this once in your app's entry point (index.js).
 */
export function registerBuildInfo() {
    if (typeof window !== 'undefined') {
        window.aiyaEarendil = function () {
            console.log(
                '%c\n' +
                    '  ██████╗  █████╗ ███╗   ██╗██████╗ ██╗██╗   ██╗███╗   ███╗\n' +
                    '  ██╔══██╗██╔══██╗████╗  ██║██╔══██╗██║██║   ██║████╗ ████║\n' +
                    '  ██████╔╝███████║██╔██╗ ██║██║  ██║██║██║   ██║██╔████╔██║\n' +
                    '  ██╔═══╝ ██╔══██║██║╚██╗██║██║  ██║██║██║   ██║██║╚██╔╝██║\n' +
                    '  ██║     ██║  ██║██║ ╚████║██████╔╝██║╚██████╔╝██║ ╚═╝ ██║\n' +
                    '  ╚═╝     ╚═╝  ╚═╝╚═╝  ╚═══╝╚═════╝ ╚═╝ ╚═════╝ ╚═╝     ╚═╝\n',
                'color: #6B5CE7; font-family: monospace; font-weight: bold;'
            )
            console.log(
                '%c BUILD INFO ',
                'background: #6B5CE7; color: #fff; font-size: 14px; padding: 4px; border-radius: 4px;'
            )
            console.log(
                '%c Deploy Tag: %c' + BUILD_INFO.deployTag,
                'color: #888;',
                'color: #6B5CE7; font-weight: bold;'
            )
            console.log(
                '%c Author:     %c' + BUILD_INFO.author,
                'color: #888;',
                'color: #4B9FE1;'
            )
            console.log(
                '%c Build Time: %c' + BUILD_INFO.buildTime,
                'color: #888;',
                'color: #4B9FE1;'
            )
            if (BUILD_INFO.dirty === 'true') {
                console.log(
                    '%c WARNING: Built from dirty working directory (uncommitted changes)',
                    'color: #E74C3C; font-weight: bold;'
                )
            }
            console.log('')
            return BUILD_INFO
        }
    }
}

export default BUILD_INFO
